import {
  DEFAULT_FETCHING_NEWS_OPTIONS,
  fetchNewsArticles,
  useFetchNewsArticles,
} from "@/apis/queryFunctions/news";
import { newsKeys } from "@/apis/queryKeys";
import Container from "@/common/Layout/Container/Container";
import NewCardNew from "@/common/NewCardNew";
import NewCardProSub from "@/common/NewCardProSub";
import AppBreadcrumbs from "@/common/components/Breadcrumbs";
import DefaultSEO from "@/common/components/DefaultSEO";
import SlideNews from "@/common/components/SlideNews";
import useTrans from "@/hooks/useTrans";
import { Box, Flex, Grid, Text, Title } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import { QueryClient, dehydrate } from "@tanstack/react-query";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";


export default function NewsPage() {
  const { locale } = useRouter();
  const trans = useTrans();
  const { data: hlnews } = useFetchNewsArticles({
    ...DEFAULT_FETCHING_NEWS_OPTIONS,
    condition: {
      ...DEFAULT_FETCHING_NEWS_OPTIONS.condition,
      ngon_ngu: locale,
      thong_tin_km: true,
    },
  });
  const breadcrumbs = [
    {
      title: locale === "vi" ? "Trang chủ" : "Home",
      href: "/",
    },
    {
      title: locale === "vi" ? "Tin tức Việt Thiên" : "Viet Thien News",
      href: "/tin-tuc",
    },
  ];
  const [page, setPage] = useState(1);
  const [options, setOptions] = React.useState({
    limit: 2000,
    page: 1,
    condition: {
      ngon_ngu: locale,
    },
  });
  console.log('update_84')

  const { data: news } = useFetchNewsArticles(options);
  
  useEffect(() => {
    setOptions((prevOps) => ({
      ...prevOps,
      page,
      condition: {
        ...prevOps?.condition,
        ngon_ngu: locale,
      },
    }));
  }, [page, locale]);

  const seo = {
    title: ["Tin tức Việt Thiên"]
  };

  const renderNews = (title, type, link) => (
    <div>
      <Link
        scroll={false}
        href={`/tin-tuc/${link}`}
      >
        <a>
          <Title align="center" c="#000" bg="#fff" order={1} size="h4" mb={20} /* p="xs" */>
            {title}
          </Title>
        </a>
      </Link>

      <div style={{paddingBottom: "15px"}}>
        {news
            ? news
                .filter((item) => item.loai_tin_tuc === type)
                .slice(0, 1)
                .map((item) => (
                  <div  key={item._id}>
                    <NewCardProSub item={item} />
                  </div>
                ))
            : Array(process.env.NEWS_LOADING_LIMIT)
                .fill(undefined)
                .map((item, i) => (
                  <div key={i}>
                    <NewCardNew item={item} isLoading />
                  </div>
                ))}
      </div>

      <Flex mih={50} gap={20} justify="flex-start" align="flex-start" direction="column">
        {news
          ? news
              .filter((item) => item.loai_tin_tuc === type)
              .slice(1, 5)
              .map((item) => (
                <div  key={item._id}>
                  <NewCardNew item={item} />
                </div>
              ))
          : Array(process.env.NEWS_LOADING_LIMIT)
              .fill(undefined)
              .map((item, i) => (
                <div key={i}>
                  <NewCardNew item={item} isLoading />
                </div>
              ))}
      </Flex>
      <Link scroll={false} href={`/tin-tuc/${link}`}>
      <a style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop:"18px" }}>
        <Text bg="#fff" s p="10px 20px 10px 20px" size={16} weight={700} display="inline-flex"  sx={{ borderRadius: "10px",}}>{trans?.homeAbout.seeMore}<IconArrowRight size={20} style={{ margin: "3px 0 0 10px" }} /></Text>
      </a>

      </Link>
    </div>
  );


  return (
    <div>
      <DefaultSEO seo={seo} />
      {/* <BannerTop position="tin-tuc-viet-thien" aspectRatio="2.44" /> */}
      <Container size = "xl" mt = {20}>
      <AppBreadcrumbs items={breadcrumbs} isLoading={!breadcrumbs} />
      {hlnews?.length>0 && (
        <Box mt={20} pt={10} pb={30} bg="#F8F8F8">
          <Title align="center" bg="#fff" c="#000" order={1} size="h4" mb={20} p="xs">
            {locale === "vi" ? "Tin tức nổi bật" : "Hot news"}
          </Title>
          <SlideNews news={hlnews}/>
        </Box>
      )}

        <Box py={20}>

          <Box pt="xl" >
            <Grid justify="space-between" align="flex-start" gutter={50} >
              <Grid.Col xs={12} sm={6} lg={4}>
                  {renderNews(
                    locale === "vi" ? "Tin tức trà" : "Tea news",
                    "Tin tức",
                    "tra"
                  )}
              </Grid.Col>
              <Grid.Col xs={12} sm={6} lg={4}> 
                  {renderNews(
                    locale === "vi" ? "Tin tức cafe" : "Coffee news",
                    "Tin tức cà phê",
                    "ca-phe"
                  )}
              </Grid.Col>
              <Grid.Col xs={12} sm={6} lg={4}>
                  {renderNews(
                    locale === "vi" ? "Tin tức nông sản" : "Agriculture news",
                    "Tin tức Việt Thiên",
                    "nong-san"
                  )}
              </Grid.Col>
            </Grid>
          </Box>
        </Box>
      </Container>
    </div>
  );
}

export async function getStaticProps({ locale }) {
  const queryClient = new QueryClient();
  const newsOptions = {
    ...DEFAULT_FETCHING_NEWS_OPTIONS,
    condition: {
      ...DEFAULT_FETCHING_NEWS_OPTIONS.condition,
      ngon_ngu: locale,
    },
  };

  await queryClient.prefetchQuery(newsKeys.list(newsOptions), () =>
    fetchNewsArticles(newsOptions)
  );

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 60,
  };
}
